/**
 * Returns whether the visible portion of an intersecting element is not
 * covered by another element. The sample point must come from intersectionRect:
 * a tall, partially visible block can have its full-element center off-screen.
 */
export function isVisibleIntersectionUncovered(entry: IntersectionObserverEntry): boolean {
  if (!entry.isIntersecting) return false;

  const { left, top, width, height } = entry.intersectionRect;
  if (width <= 0 || height <= 0) return false;
  if (typeof document.elementFromPoint !== 'function') return true;

  const visibleCenterX = left + width / 2;
  const visibleCenterY = top + height / 2;
  const topElement = document.elementFromPoint(visibleCenterX, visibleCenterY);

  return Boolean(topElement && (entry.target as HTMLElement).contains(topElement));
}
